import { CommonHttpHelper, NO_DATA_MESSAGE, BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const getOrgRoleFields = (orgRoleId, state, setState) => {
  if (state.isArrayLoading !== true && orgRoleId && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      orgRoleId,
      message: 'Loading...'
    };
    setState(newState);

    const orgRoleIdForUrl = orgRoleId ? encodeURIComponent(orgRoleId) : 'NaN';
    const url = `/OrgRoleField/OrgRole/${orgRoleIdForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            orgRoleId,
            arrayData,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  orgRoleId: ''
};

const OrgRoleFieldData = { INITIAL_STATE, getOrgRoleFields };

export default OrgRoleFieldData;